import * as React from 'react';
import { ISuggestionGroup } from './suggestion_collection';
import Suggestion from './suggestion';
import { IUserContext, withUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';

interface IProps extends IUserContext {
  suggestions: ISuggestionGroup[];
  lastTypedValue: string;
  selectSuggestion: Function;
  selectedSuggestion: Suggestion;
}

export class Dropdown extends React.Component<IProps, null> {
  renderSection(section, sectionIdx) {
    return (
      <div
        key={sectionIdx}
        className="site-search__dropdown__section"
      >
        {this.renderSectionHeading(section)}
        {section.results.map((r, idx) => this.renderSectionItem(r, idx))}
      </div>
    );
  }

  renderSectionHeading(section) {
    if (!section.heading) { return false; }
    if (!section.results.length) { return false; }

    return (
      <div className="site-search__dropdown__section__heading">
        {section.heading}
      </div>
    );
  }

  renderSectionItem(suggestion, idx) {
    const isActive = suggestion.positionEqual(this.props.selectedSuggestion);

    return (
      <suggestion.component
        key={idx}
        suggestion={suggestion}
        active={isActive}
        lastTypedValue={this.props.lastTypedValue}
        selectSuggestion={this.props.selectSuggestion}
      />
    );
  }

  render() {
    return (
      <div className="site-search__dropdown">
        {this.props.suggestions.map((s, idx) => this.renderSection(s, idx))}
      </div>
    );
  }
}

export default withUserContext(Dropdown);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/site_search/dropdown.tsx